"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const UserTransactionType_1 = require("../transactions/User/UserTransactionType");
class ValidatorService {
    constructor(cryptoService, transactionTypeResolver) {
        this.cryptoService = cryptoService;
        this.transactionTypeResolver = transactionTypeResolver;
    }
    validateBase(storedTransactions, tx) {
        const hash = this.cryptoService.calculateTransactionHash(tx.creator, tx.type, tx.model);
        if (hash !== tx.hash) {
            throw new Error('Invalid hash');
        }
        if (tx.signatures.length === 0) {
            throw new Error('No signatures');
        }
        if (tx.signatures[0].publicKey !== tx.creator.publicKey) {
            throw new Error('Wrong first signature');
        }
        if (tx.type !== UserTransactionType_1.UserTransactionType.t) {
            const storedUser = ValidatorService.getUserByPublicKey(storedTransactions, tx.creator.publicKey);
            if (!storedUser) {
                throw new Error('Creator of transactions not found');
            }
            if (storedUser.login !== tx.creator.login) {
                throw new Error('Login mismatch of creator');
            }
        }
        for (const signature of tx.signatures) {
            if (!this.cryptoService.verifySignature(tx, signature)) {
                throw new Error('Invalid signature');
            }
        }
    }
    validateSpecific(storedTransactions, tx) {
        return __awaiter(this, void 0, void 0, function* () {
            const specificValidator = this.transactionTypeResolver.getSpecificValidator(tx.type);
            yield specificValidator.validate(storedTransactions, tx);
        });
    }
    static getUserByPublicKey(storedTransactions, publicKey) {
        for (const tx of storedTransactions) {
            if (tx.type !== UserTransactionType_1.UserTransactionType.t) {
                continue;
            }
            const user = tx.model;
            if (user.publicKey === publicKey) {
                return user;
            }
        }
        return null;
    }
}
exports.ValidatorService = ValidatorService;
